export { default } from './InfoDialog';
